import { render, staticRenderFns } from "./SobreNosotros.vue?vue&type=template&id=177990d5&scoped=true"
import script from "./SobreNosotros.vue?vue&type=script&lang=js"
export * from "./SobreNosotros.vue?vue&type=script&lang=js"
import style0 from "./SobreNosotros.vue?vue&type=style&index=0&id=177990d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177990d5",
  null
  
)

export default component.exports